const NUMERIC_INPUT_PATTERN = /^\s*-?\d*\.?\d*\s*$/;

export const normalizeNumericInput = (value: string) => value.replace(/,/g, "");

export const parseNumericInput = (value: string): { isValid: boolean; value: number | "" } => {
    const normalizedValue = normalizeNumericInput(value);
    const isValid = NUMERIC_INPUT_PATTERN.test(normalizedValue) || value === "";

    if (!isValid) {
        return { isValid: false, value: "" };
    }

    return {
        isValid: true,
        value: normalizedValue === "" ? "" : parseFloat(normalizedValue),
    };
};
